export default {

	files: {

		// FILES
		size: {
			title: 'Größe',
		}, filename: {
			title: 'Dateiname',
		},
		file_path: {
			title: 'Dateipfad (intern)',
		},
		internal_filename: {
			title: 'Dateiname (intern)',
		},
		customer_id: {
			title: 'Kundenreferenz',
		},
		// FILES
		file_group: {
			title: 'Dateigruppe',
			values: {
				4: 'Kundenrechnung',
				5: 'Kundengutschrift',
				6: 'Versanddatei Anschreiben + Energieausweis + Rechnung',
				50: 'Dateianhänge aus Kundendienst',
				51: 'Dateianhänge aus Kundendienst',
				101: 'Energieausweis (Vorschau)',
				102: 'Energieausweis (Original)',
				103: 'Energieausweis Aushang',
				105: 'Formblätter',
				106: 'Formblätter PDF',
				110: 'Versorgerrechnung (Heizkosten, Strom, Gas)',
				208: 'Gebäudebild (GSV)',
				209: 'Gebäudebild für Ausweis (ausgewählt)',
				210: 'Gebäudebilder für Ausweis',
				211: 'Klimaanlage',
				212: 'Typenschilds der Heizungsanlage',
				217: 'Typenschilds der 2. Heizungsanlage',
				213: 'Dach',
				214: 'Fenster',
				215: 'Außenwand',
				216: 'Grundriss',
				218: 'WSchVo 1977',
				220: 'Sonstige Dokumente',
				221: 'Zertifikat (Nah-/Fernwärme)',
			},
		},
	},

	customer: {
		id: {
			title: 'Auftragsnummer',
		},
		uuid: {
			title: 'Eindeutige ID',
		},
		order_tos: {
			title: 'AGB zustimmung',
		},
		coupon_code: {
			title: 'Rabattcode',
		},
		vat_id: {
			title: 'Umsatzsteuer-ID',
		},
		product_price: {
			title: 'Betrag für Energieausweis',
		},
		payment_bank_holder: {
			title: 'Kontoinhaber',
		},
		payment_bank_iban: {
			title: 'IBAN',
		},
		user_id: {
			title: 'Kundennummer',
		},
		gclid: {
			title: 'Google Click-ID',
		},
		customer_id: {
			title: 'Kundenreferenz (intern)',
		},
		invoice_number: {
			title: 'Rechnungsnummer',
		},
		invoice_uuid: {
			title: 'Eindeutige Rechnungs-ID',
		},
		order_shipping_process_date: {
			title: 'Lieferdatum & DIBt-Registrierungsdatum',
		},
		order_date: {
			title: 'Zeit der Lieferung',
		},
		payment_token: {
			title: 'Eindeutige Zahlungs-ID',
		},
		company_name: {
			title: 'Firmenname',
		},
		ip: {
			title: 'IP-Adresse des Kunden',
		},
		order_status: {
			title: 'Bestellstatus',
			values: {
				'': '-',
				1: 'Lead',
				2: 'Beauftragt',
				3: 'Abgeschlossen',
				4: 'Storniert',
			},
		},


		legal_version: {
			title: 'GEG-Version',
		},

		// Zahlung
		payment_method: {
			title: 'Zahlungsmethode',
			values: {
				'': '-',
				// 'banktransfer': 'Überweisung',
				// 'bt_cc': 'Kreditkarte (BrainTree)',
				// 'dd': 'Lastschrift',

				//Mollie
				'pp': 'PayPal  (PayPal-Express)',
				'pp_paypal': 'PayPal',
				'pp_giropay': 'giroPay (PayPal)',
				'pp_sofort': 'SOFORT (PayPal)',
				'pp_ideal': 'iDEAL (PayPal)',
				'pp_card': 'Kreditkarte (PayPal)',
				'pp_mercadopago': 'Mercado Pago (PayPal)',
				'pp_sepa': 'Lastschrift (PayPal)',


				//Mollie
				'mollie': 'Verschiedene (mollie)',
				'mollie_creditcard': 'Kreditkarte (mollie)',
				'mollie_directdebit': 'Lastschrift (mollie)',
				'mollie_banktransfer': 'Banküberweisung (mollie)',
				'mollie_giropay': 'giroPay (mollie)',
				'mollie_paypal': 'PayPal (mollie)',
				'mollie_sofort': 'SOFORT (mollie)',
				'mollie_applepay': 'ApplePay (mollie)',
				'mollie_klarnapaylater': 'Klarna Pay Later (mollie)',
				'mollie_klarnapaynow': 'Klarna Pay Now (mollie)',
				'mollie_klarna': 'Klarna (mollie)',
				'mollie_klarnasliceit': 'Klarna Pay Now (mollie)',

				//Stripe
				// 'stripe_card': 'Kreditkarte (stripe)',
				// 'stripe_giropay': 'giroPay (stripe)',
				// 'stripe_sepa_debit': 'Lastschrift (stripe)',
				// 'stripe_sofort': 'SOFORT (stripe)',
				// 'stripe_google_pay': 'GooglePay (stripe)',
			},
		},

		order_short_revocation_period: {
			title: 'Kurze Widerrufsfrist der Bestellung',
			values: {
				'': '-',
				1: 'vorz. Auftragsausführung',
				2: '14 Tage Widerrufsrecht',
			},
		},


		address_country: {
			title: 'Land',
			values: {
				'AFG': 'Afghanistan',
				'ALA': 'Åland Islands',
				'ALB': 'Albania',
				'DZA': 'Algeria',
				'ASM': 'American Samoa',
				'AND': 'Andorra',
				'AGO': 'Angola',
				'AIA': 'Anguilla',
				'ATA': 'Antarctica',
				'ATG': 'Antigua and Barbuda',
				'ARG': 'Argentina',
				'ARM': 'Armenia',
				'ABW': 'Aruba',
				'AUS': 'Australia',
				'AUT': 'Österreich',
				'AZE': 'Azerbaijan',
				'BHS': 'Bahamas',
				'BHR': 'Bahrain',
				'BGD': 'Bangladesh',
				'BRB': 'Barbados',
				'BLR': 'Belarus',
				'BEL': 'Belgium',
				'BLZ': 'Belize',
				'BEN': 'Benin',
				'BMU': 'Bermuda',
				'BTN': 'Bhutan',
				'BOL': 'Bolivia, Plurinational State of',
				'BES': 'Bonaire, Sint Eustatius and Saba',
				'BIH': 'Bosnia and Herzegovina',
				'BWA': 'Botswana',
				'BVT': 'Bouvet Island',
				'BRA': 'Brazil',
				'IOT': 'British Indian Ocean Territory',
				'BRN': 'Brunei Darussalam',
				'BGR': 'Bulgaria',
				'BFA': 'Burkina Faso',
				'BDI': 'Burundi',
				'KHM': 'Cambodia',
				'CMR': 'Cameroon',
				'CAN': 'Canada',
				'CPV': 'Cape Verde',
				'CYM': 'Cayman Islands',
				'CAF': 'Central African Republic',
				'TCD': 'Chad',
				'CHL': 'Chile',
				'CHN': 'China',
				'CXR': 'Christmas Island',
				'CCK': 'Cocos (Keeling) Islands',
				'COL': 'Colombia',
				'COM': 'Comoros',
				'COG': 'Congo',
				'COD': 'Congo, the Democratic Republic of the',
				'COK': 'Cook Islands',
				'CRI': 'Costa Rica',
				'CIV': 'Côte d\'Ivoire',
				'HRV': 'Croatia',
				'CUB': 'Cuba',
				'CUW': 'Curaçao',
				'CYP': 'Cyprus',
				'CZE': 'Czech Republic',
				'DNK': 'Denmark',
				'DJI': 'Djibouti',
				'DMA': 'Dominica',
				'DOM': 'Dominican Republic',
				'ECU': 'Ecuador',
				'EGY': 'Egypt',
				'SLV': 'El Salvador',
				'GNQ': 'Equatorial Guinea',
				'ERI': 'Eritrea',
				'EST': 'Estonia',
				'ETH': 'Ethiopia',
				'FLK': 'Falkland Islands (Malvinas)',
				'FRO': 'Faroe Islands',
				'FJI': 'Fiji',
				'FIN': 'Finland',
				'FRA': 'France',
				'GUF': 'French Guiana',
				'PYF': 'French Polynesia',
				'ATF': 'French Southern Territories',
				'GAB': 'Gabon',
				'GMB': 'Gambia',
				'GEO': 'Georgia',
				'DEU': 'Deutschland',
				'GHA': 'Ghana',
				'GIB': 'Gibraltar',
				'GRC': 'Greece',
				'GRL': 'Greenland',
				'GRD': 'Grenada',
				'GLP': 'Guadeloupe',
				'GUM': 'Guam',
				'GTM': 'Guatemala',
				'GGY': 'Guernsey',
				'GIN': 'Guinea',
				'GNB': 'Guinea-Bissau',
				'GUY': 'Guyana',
				'HTI': 'Haiti',
				'HMD': 'Heard Island and McDonald Islands',
				'VAT': 'Holy See (Vatican City State)',
				'HND': 'Honduras',
				'HKG': 'Hong Kong',
				'HUN': 'Hungary',
				'ISL': 'Iceland',
				'IND': 'India',
				'IDN': 'Indonesia',
				'IRN': 'Iran, Islamic Republic of',
				'IRQ': 'Iraq',
				'IRL': 'Ireland',
				'IMN': 'Isle of Man',
				'ISR': 'Israel',
				'ITA': 'Italy',
				'JAM': 'Jamaica',
				'JPN': 'Japan',
				'JEY': 'Jersey',
				'JOR': 'Jordan',
				'KAZ': 'Kazakhstan',
				'KEN': 'Kenya',
				'KIR': 'Kiribati',
				'PRK': 'Korea, Democratic Peoples Republic of',
				'KOR': 'Korea, Republic of',
				'KWT': 'Kuwait',
				'KGZ': 'Kyrgyzstan',
				'LVA': 'Latvia',
				'LBN': 'Lebanon',
				'LSO': 'Lesotho',
				'LBR': 'Liberia',
				'LBY': 'Libya',
				'LIE': 'Liechtenstein',
				'LTU': 'Lithuania',
				'LUX': 'Luxembourg',
				'MAC': 'Macao',
				'MKD': 'Macedonia, the former Yugoslav Republic of',
				'MDG': 'Madagascar',
				'MWI': 'Malawi',
				'MYS': 'Malaysia',
				'MDV': 'Maldives',
				'MLI': 'Mali',
				'MLT': 'Malta',
				'MHL': 'Marshall Islands',
				'MTQ': 'Martinique',
				'MRT': 'Mauritania',
				'MUS': 'Mauritius',
				'MYT': 'Mayotte',
				'MEX': 'Mexico',
				'FSM': 'Micronesia, Federated States of',
				'MDA': 'Moldova, Republic of',
				'MCO': 'Monaco',
				'MNG': 'Mongolia',
				'MNE': 'Montenegro',
				'MSR': 'Montserrat',
				'MAR': 'Morocco',
				'MOZ': 'Mozambique',
				'MMR': 'Myanmar',
				'NAM': 'Namibia',
				'NRU': 'Nauru',
				'NPL': 'Nepal',
				'NLD': 'Netherlands',
				'NCL': 'New Caledonia',
				'NZL': 'New Zealand',
				'NIC': 'Nicaragua',
				'NER': 'Niger',
				'NGA': 'Nigeria',
				'NIU': 'Niue',
				'NFK': 'Norfolk Island',
				'MNP': 'Northern Mariana Islands',
				'NOR': 'Norway',
				'OMN': 'Oman',
				'PAK': 'Pakistan',
				'PLW': 'Palau',
				'PSE': 'Palestinian Territory, Occupied',
				'PAN': 'Panama',
				'PNG': 'Papua New Guinea',
				'PRY': 'Paraguay',
				'PER': 'Peru',
				'PHL': 'Philippines',
				'PCN': 'Pitcairn',
				'POL': 'Poland',
				'PRT': 'Portugal',
				'PRI': 'Puerto Rico',
				'QAT': 'Qatar',
				'REU': 'Réunion',
				'ROU': 'Romania',
				'RUS': 'Russian Federation',
				'RWA': 'Rwanda',
				'BLM': 'Saint Barthélemy',
				'SHN': 'Saint Helena, Ascension and Tristan da Cunha',
				'KNA': 'Saint Kitts and Nevis',
				'LCA': 'Saint Lucia',
				'MAF': 'Saint Martin (French part)',
				'SPM': 'Saint Pierre and Miquelon',
				'VCT': 'Saint Vincent and the Grenadines',
				'WSM': 'Samoa',
				'SMR': 'San Marino',
				'STP': 'Sao Tome and Principe',
				'SAU': 'Saudi Arabia',
				'SEN': 'Senegal',
				'SRB': 'Serbia',
				'SYC': 'Seychelles',
				'SLE': 'Sierra Leone',
				'SGP': 'Singapore',
				'SXM': 'Sint Maarten (Dutch part)',
				'SVK': 'Slovakia',
				'SVN': 'Slovenia',
				'SLB': 'Solomon Islands',
				'SOM': 'Somalia',
				'ZAF': 'South Africa',
				'SGS': 'South Georgia and the South Sandwich Islands',
				'SSD': 'South Sudan',
				'ESP': 'Spain',
				'LKA': 'Sri Lanka',
				'SDN': 'Sudan',
				'SUR': 'Suriname',
				'SJM': 'Svalbard and Jan Mayen',
				'SWZ': 'Swaziland',
				'SWE': 'Sweden',
				'CHE': 'Schweiz',
				'SYR': 'Syrian Arab Republic',
				'TWN': 'Taiwan, Province of China',
				'TJK': 'Tajikistan',
				'TZA': 'Tanzania, United Republic of',
				'THA': 'Thailand',
				'TLS': 'Timor-Leste',
				'TGO': 'Togo',
				'TKL': 'Tokelau',
				'TON': 'Tonga',
				'TTO': 'Trinidad and Tobago',
				'TUN': 'Tunisia',
				'TUR': 'Turkey',
				'TKM': 'Turkmenistan',
				'TCA': 'Turks and Caicos Islands',
				'TUV': 'Tuvalu',
				'UGA': 'Uganda',
				'UKR': 'Ukraine',
				'ARE': 'United Arab Emirates',
				'GBR': 'United Kingdom',
				'USA': 'United States',
				'UMI': 'United States Minor Outlying Islands',
				'URY': 'Uruguay',
				'UZB': 'Uzbekistan',
				'VUT': 'Vanuatu',
				'VEN': 'Venezuela, Bolivarian Republic of',
				'VNM': 'Viet Nam',
				'VGB': 'Virgin Islands, British',
				'VIR': 'Virgin Islands, U.S.',
				'WLF': 'Wallis and Futuna',
				'ESH': 'Western Sahara',
				'YEM': 'Yemen',
				'ZMB': 'Zambia',
				'ZWE': 'Zimbabwe',
			},
		},

		/**
		 * Step 6
		 */
		salutation: {
			title: 'Anrede',
			values: {
				"male": 'Herr',
				"female": 'Frau',
				"other": 'Sonstiges',
			},
		},

		order_type: {
			title: 'Bestellart',
			values: {
				1: 'Privat-Eigentümer',
				// 2: 'Immobilienmakler',
				// 3: 'Anderes Gewerbe',
				// 4: 'Hausverwaltung',
				5: 'Gewerblich',
				6: 'Gewerblich (ohne USt.ID)',
			},
		},


		//Kundenzahlung
		payment_status: {
			title: 'Zahlungsstatus',
			values: {
				'': '-',
				1: 'Nicht bezahlt',
				2: 'Bezahlt',
				3: 'deprecated',
				4: 'deprecated',
				5: 'deprecated',
				6: 'Warte auf Einbuchung',
				7: 'Bezahlt nach Mahnung',
				8: 'Mahnstufe 1',
				9: 'Mahnstufe 2',
				10: 'Inkasso',
				11: 'deprecated',
				12: 'Forderungsverzicht (temporär)',
				13: 'Forderungsverzicht (dauerhaft)',
				14: 'IBAN fehlerhaft',
				15: 'In Queue / Locked',
				16: 'Chargeback',
			},
		},

		payment_collection_status: {
			title: 'Inkassostatus',
			values: {
				'': '-', 1: 'Bereit zur Inkassübergabe (Auftrag überprüft)',
			},
		},
		order_shipping_date: {
			title: 'Lieferdatum',
		},

		order_dibt_id: {
			title: 'DIBt Registriernummer',
		},
		hold: {
			title: 'Wiedervorlage',
		},
		notice: {
			title: 'Notiz (intern)',
		},
		notice_dev: {
			title: 'Notiz (intern, Technik)',
		},
		notice_customer: {
			title: 'Notiz (Kunde)',
		},
		first_name: {
			title: 'Vorname (Rechnung)',
		},
		last_name: {
			title: 'Nachname (Rechnung)',
		},
		email: {
			title: 'E-Mail',
		},
		address: {
			title: 'Adresse (Rechnung)',
		},
		address_suffix: {
			title: 'Adresszusatz (Rechnung)',
		},
		address_zip: {
			title: 'PLZ (Rechnung)',
		},
		address_city: {
			title: 'Stadt (Rechnung)',
		},
		order_total_price: {
			title: 'Gesamtpreis',
		},

		// Korrekturrechnung
		credit_status: {
			title: 'Gutschriftstatus',
			values: {
				'': '-',
				null: '-',
				1: 'Warte auf Erstellung',
				2: 'Erstellt',
				3: 'Nicht Erstellt',
				4: 'Manuelle Änderung in LEX notw.',
			},
		},

		credit_payment_status: // Rückerstattung Zahlungsstatus
			{
				title: 'Status der Rückerstattung',
				values: {
					'': '-',
					1: 'Nicht erstattet',
					2: 'Erstattet',
					3: 'Warte auf Erstattung',
					4: 'Erstattung nicht notw.',
				},
			},
	},

	energieausweis: {
		order_correct_data_confirmed: {
			title: "Bestätigung auf Richtigkeit der Daten",
		},
		id: {
			title: "ID",
		},
		heater_building_year_appendix: {
			title: "Baujahr der Heizungsanlage freitext",
		},
		property_building_year_appendix: {
			title: "Baujahr des Objekts freitext",
		},

		ba_pv_area: {
			title: "Photovaltaikfläche",
		},

		biomasse_checkbox: {
			title: "Abfrage für Biomasse",
		},
		customer_id: {
			title: "Auftragsnummer",
		},
		property_space: {
			title: "Wohnfläche",
		},
		order_optional_express_price: {
			title: "Preis für optionale Expressbestellung",
		},
		order_enhanced_verification_price: {
			title: "Preis für erweiterte Überprüfung",
		},
		order_correct_option_price: {
			title: "Preis für Korrekturoption",
		},
		order_expert_consulting_price: {
			title: "Preis für Expertenberatung",
		},
		basement_percentage: {
			title: "Beheizter Anteil des Kellers",
		},
		basement_height: {
			title: "Höhe des Kellers",
		},
		ba_full_floor_height: {
			title: "Mittlere Vollgeschosshöhe (inkl. Decke)",
		},
		ba_attic_height: {
			title: "Dachgeschosshöhe",
		},
		ba_attic2_height: {
			title: "2. Dachgeschosshöhe",
		},
		ba_roof_windows_year: {
			title: "Baujahr der Dachfenster",
		},
		ba_windows_year: {
			title: "Baujahr der Fenster",
		},
		ba_heater_volume: {
			title: "Volumen Heizungskessel",
		},
		ba_roof_windows_glas_type: {
			title: "Art der Dachfenster",
		},
		basement_windows: {
			title: "Fenster Keller",
		},
		renewable_energy_solar: {
			title: "Nutzung von erneuerbaren Energien: Solar",
		},
		renewable_energy_pv: {
			title: "Nutzung von erneuerbaren Energien: PV",
		},
		renewable_energy_biomass: {
			title: "Nutzung von erneuerbaren Energien: Biomasse",
		},
		renewable_energy_wp: {
			title: "Nutzung von erneuerbaren Energien: Wärmepumpe",
		},
		renewable_energy_usages_heating: {
			title: "Nutzung von erneuerbaren Energien für: Heizung",
		},
		renewable_energy_usages_water: {
			title: "Nutzung von erneuerbaren Energien für: Warmwasser",
		},
		renewable_energy_usages_energy: {
			title: "Nutzung von erneuerbaren Energien für: Strom",
		},
		property_building_year: {
			title: 'Baujahr des Gebäudes',
		},
		billing_period1_start: {
			title: 'Abrechnungszeitraum 1 (start)',
		},
		billing_period2_start: {
			title: 'Abrechnungszeitraum 2 (start)',
		},
		billing_period3_start: {
			title: 'Abrechnungszeitraum 3 (start)',
		},
		billing_period1_end: {
			title: 'Abrechnungszeitraum 1 (end)',
		},
		billing_period2_end: {
			title: 'Abrechnungszeitraum 2 (end)',
		},
		billing_period3_end: {
			title: 'Abrechnungszeitraum 3 (end)',
		},
		billing_period1_usage: {
			title: 'Verbrauch Abrechnungszeitraum 1 ',
		},
		billing_period2_usage: {
			title: 'Verbrauch Abrechnungszeitraum 2 ',
		},
		billing_period3_usage: {
			title: 'Verbrauch Abrechnungszeitraum 3 ',
		},
		water_heating_percent: {
			title: 'Wasserverbrauch Anteil',
		},
		property_units: {
			title: 'Anzahl Wohnungen',
			values: {
				1: '1 Wohnung',
				2: '2 Wohnungen',
				3: '3 Wohnungen',
				4: '4 Wohnungen',
				5: '5 Wohnungen',
				6: '6 Wohnungen',
				7: '7 Wohnungen',
				8: '8 Wohnungen',
				9: '9 Wohnungen',
				10: '10 Wohnungen',
			},
		},

		reason_of_creation: {
			title: 'Erstellungsgrund',
			values: {
				//	1: 'Neubau',
				2: 'Vermietung/Verkauf',
				// 3: 'Modernisierung/Erweiterung',
				4: 'Sonstiges (freiwillig)',
				// 5: 'Aushangspflicht',
			},
		},

		order_optional_booking_status: {
			title: 'Optionaler Buchungsstatus der Bestellung',
			values: {
				1: "✅ Gebucht",
				2: "Nicht gebucht",
			},
		},

		order_optional_postal_delivery: {
			title: 'Optionaler Postversand von Energieausweis und Rechnung',
			values: {1: 'Gebucht', 2: 'Nicht gebucht'},
		},

		order_optional_postal_delivery_status: {
			title: 'Optionaler Postlieferstatus der Bestellung',
			values: {
				1: 'Versand ausstehend',
				2: 'Versand',
				3: "☑️️ Übergeben an Hauptauftrag",
			},
		},

		order_optional_postal_delivery_price: {
			title: 'Postversand Preis gesamt',
		},

		order_optional_postal_delivery_amount: {
			title: 'Anzahl der Exemplare',
			values: {
				null: '-',
				1: '1 Exemplar',
				2: '2 Exemplare',
				3: '3 Exemplare',
				4: '4 Exemplare',
				5: '5 Exemplare',
				6: '6 Exemplare',
			},
		},

		order_enhanced_verification: {
			title: 'Erweiterter Verifizierungsstatus',
			values: {1: 'Gebucht', 2: 'Nicht gebucht'},
		},
		order_enhanced_verification_status: {
			title: 'Erweiterter Verifizierungsstatus der Bestellung',
			values: {1: 'In Überprüfung', 2: 'Kontakt zum Kunden aufgenommen', 3: 'Überprüfung abgeschlossen'},
		},

		order_correct_option: {
			title: 'Korrekturoptionsstatus',
			values: {
				1: 'Ja',
				2: 'Nein',
			},

		},
		order_correct_option_status: {
			title: 'Korrekturoptionsstatus der Bestellung',
			values: {
				1: 'Korrektur möglich',
				2: 'Korrektur durchgeführt (Weitere Korrektur nicht möglich)',
			},

		},

		order_optional_express: {
			title: 'Expressoption',
			values: {
				1: 'Ja',
				2: 'Nein',
			},
		},
		order_expert_consulting: {
			title: 'Expertenberatung',
			values: {
				1: 'Ja',
				2: 'Nein',
			},
		},
		order_expert_consulting_status: {
			title: 'Expertenberatungsstatus der Bestellung',
			values: {
				1: 'Terminabsprache (Termin nicht vereinbart)',
				2: 'Termin ausstehend (Termin vereinbart, Termin nicht durchgeführt)',
				3: 'Termin durchgeführt und Dienstleistung geliefert',
			},
		},
		product: {
			title: 'Produkt',
			values: {
				1: 'Verbrauchsausweis für Wohngebäude',
				2: 'Verbrauchsausweis für Nichtwohngebäude',
				3: 'Bedarfsausweis für Wohngebäude',
				9: 'Nachträgliche Buchung',
			},
		},

		product_short: {
			title: 'Produkt (Kurz)',
			values: {1: 'VA', 2: 'VA_NWG', 3: 'BA', 9: 'EW'},
		},

		ventilation_system_with_recovery: {
			title: 'Lüftungssystem mit Wärmerückgewinnung',
			values: {
				1: 'Lüftungsanlage mit Wärmerückgewinnung',
				2: 'Keine Lüftungsanlage mit Wärmerückgewinnung',
			},
		},
		air_conditioning: {
			title: 'Anlage zum Kühlen',
			values: {
				1: 'Ja',
				2: 'Nein',
			},
		},

		ventilation_system_without_recovery: {
			title: 'Lüftungssystem ohne Wärmerückgewinnung',
			values: {
				1: 'Lüftungsanlage ohne Wärmerückgewinnung',
				2: 'Keine Lüftungsanlage ohne Wärmerückgewinnung',
			},
		},

		ventilation_windows: {
			title: 'Lüftungsfenster',
			values: {
				1: 'Fensterlüftung',
				2: 'Keine Fensterlüftung',
			},
		},
		ventilation_shaft: {
			title: 'Lüftungsschacht',
			values: {
				1: 'Schachtlüftung vorhanden',
				2: 'Keine Schachtlüftung',
			},
		},

		ventilation_system_exhaust: {
			title: 'Abluftsystem',
			values: {
				1: 'Abluftanlage vorhanden',
				2: 'Keine Abluftanlage vorhanden',
			},
		},


		ba_attic_heated: {
			title: 'Beheizter Dachboden',
			values: {
				1: 'Unbeheiztes Dachgeschoss',
				2: 'Beheiztes Dachgeschoss',
				//	5: 'Kein Dachgeschoss vorhanden',
			},
		},

		ba_attic2_existing: {
			title: 'Vorhandener Dachboden 2',
			values: {
				1: 'Das Dachgeschoss besteht aus zwei Etagen.',
				2: 'Es gibt keine zweite Etage im Dachgeschoss.',
			},
		},

		ba_attic2_heated: {
			title: 'Beheizter Dachboden 2',
			values: {
				1: 'Unbeheiztes Dachgeschoss',
				2: 'Beheiztes Dachgeschoss',
				//	5: 'Kein Dachgeschoss vorhanden',
			},
		},

		basement_heated: {
			title: 'Beheizter Keller',
			values: {
				1: 'Unbeheizter Keller',
				2: 'Beheizter Keller',
				5: 'Kein Keller vorhanden / Bodenplatte',
			},
		},

		radiator_niche: {
			title: 'Heizkörpernische',
			values: {
				1: 'Heizkörpernischen vorhanden',
				2: 'Keine Heizkörpernischen vorhanden',
			},
		},

		roller_shutter_boxes: {
			title: 'Rollladenkästen',
			values: {
				1: 'nicht vorhanden',
				// 2: 'Außenliegende Rollladenkästen',
				3: 'Rollladenkästen (ungedämmt)',
				4: 'Rollladenkästen (gedämmt)',
			},
		},


		// Platte gegen Keller
		basement_ceiling: {
			title: 'Kellerdecke',
			values: {1: 'Stahlbetondecke', 2: 'Holzbalkendecke', 3: 'Sonstige'},
		},

		// Dämmung gegen Erdreich (Bodenplatte)
		basement_bottom: {
			title: 'Kellerboden',
			values: {
				1: 'Stahlbetonkonstruktion', 2: 'Holzkonstruktion', 3: 'Sonstige',
			},
		},


		ventilation_location: {
			title: 'Lüftungsort',
			values: {
				1: "innerhalb der thermischen Hülle",
				2: "Dach, außerhalb der thermischen Hülle",
				3: "Keller, außerhalb der thermischen Hülle",
			},
		},

		// @deprecated
		ventilation: {
			title: 'Lüftung',
			values: {
				1: 'Fensterlüftung',
				3: 'Anlage mit Wärmerückgewinnung',
				4: 'Anlage ohne Wärmerückgewinnung',
				//5: 'Mechanisch gekühlt',
				2: 'Schachtlüftung',
			},
		},


		/* Auch verwendet für:
		 * energy_source2
		 * energy_source_water_heating
		 * energy_source_water_heating2
		 */
		energy_source: {
			title: 'Energiequelle',
			values: {
				1: 'Erdgas',
				2: 'Biogas',
				3: 'Flüssiggas',
				4: 'Heizöl',
				5: 'Bioöl',
				6: 'Steinkohle',
				7: 'Braunkohle',
				8: 'Brennholz / Stückholz',
				9: 'Holzhackschnitzel',
				10: 'Holzpellets',
				11: 'Nah-/Fernwärme (aus Heizwerken)',
				12: 'Strom',
				13: 'Umweltwärme',
				// 14: 'Nah-/Fernwärme (fossile Energieträger)',
				15: 'Strom (Photovoltaik)',
				16: 'Nah-/Fernwärme (KWK, fossil)',
				17: 'Nah-/Fernwärme (KWK, erneuerbar)',
			},
		},

		energy_source2: {
			title: 'Energiequelle 2',
			values: {
				1: 'Erdgas',
				2: 'Biogas',
				3: 'Flüssiggas',
				4: 'Heizöl',
				5: 'Bioöl',
				6: 'Steinkohle',
				7: 'Braunkohle',
				8: 'Brennholz / Stückholz',
				9: 'Holzhackschnitzel',
				10: 'Holzpellets',
				11: 'Nah-/Fernwärme (aus Heizwerken)',
				12: 'Strom',
				13: 'Umweltwärme',
				// 14: 'Nah-/Fernwärme (fossile Energieträger)',
				15: 'Strom (Photovoltaik)',
				16: 'Nah-/Fernwärme (KWK, fossil)',
				17: 'Nah-/Fernwärme (KWK, erneuerbar)',
			},
		},

		energy_source_water_heating: {
			title: 'Energiequelle für Wassererwärmung',
			values: {
				1: 'Erdgas',
				2: 'Biogas',
				3: 'Flüssiggas',
				4: 'Heizöl',
				5: 'Bioöl',
				6: 'Steinkohle',
				7: 'Braunkohle',
				8: 'Brennholz / Stückholz',
				9: 'Holzhackschnitzel',
				10: 'Holzpellets',
				11: 'Nah-/Fernwärme (aus Heizwerken)',
				12: 'Strom',
				13: 'Umweltwärme',
				// 14: 'Nah-/Fernwärme (fossile Energieträger)',
				15: 'Strom (Photovoltaik)',
				16: 'Nah-/Fernwärme (KWK, fossil)',
				17: 'Nah-/Fernwärme (KWK, erneuerbar)',
			},
		},

		energy_source_water_heating2: {
			title: 'Energiequelle für Wassererwärmung 2',
			values: {
				1: 'Erdgas',
				2: 'Biogas',
				3: 'Flüssiggas',
				4: 'Heizöl',
				5: 'Bioöl',
				6: 'Steinkohle',
				7: 'Braunkohle',
				8: 'Brennholz / Stückholz',
				9: 'Holzhackschnitzel',
				10: 'Holzpellets',
				11: 'Nah-/Fernwärme (aus Heizwerken)',
				12: 'Strom',
				13: 'Umweltwärme',
				// 14: 'Nah-/Fernwärme (fossile Energieträger)',
				15: 'Strom (Photovoltaik)',
				16: 'Nah-/Fernwärme (KWK, fossil)',
				17: 'Nah-/Fernwärme (KWK, erneuerbar)',
			},
		},

		energy_source_usage2: {
			title: '2. Energiequelle vorhanden?',
			values: {1: "Ja, zweiter Energieträger vorhanden", 2: "Nein, nur ein Energieträger vorhanden"},
		},

		energy_source_unit: {
			title: 'Einheit der Energiequelle',
			values: {1: 'm³', 2: 'kWh', 3: 'kg', 4: 'Schüttraummeter (SRm)', 5: 'Liter (l)'},
		},
		energy_source_unit_water_heating: {
			title: 'Einheit der Energiequelle',
			values: {1: 'm³', 2: 'kWh', 3: 'kg', 4: 'Schüttraummeter (SRm)', 5: 'Liter (l)'},
		},

		energy_source2_unit: {
			title: 'Einheit der 2. Energiequelle',
			values: {1: 'm³', 2: 'kWh', 3: 'kg', 4: 'Schüttraummeter (SRm)', 5: 'Liter (l)'},
		},
		water_heating2_method: {
			title: 'Warmwasserbereitung (sekundär)',
			values: {1: 'm³', 2: 'kWh', 3: 'kg', 4: 'Schüttraummeter (SRm)', 5: 'Liter (l)'},
		},


		cooling_type: {
			title: 'Kühlungsart',
			values: {1: 'Passive Kühlung', 2: 'Gelieferte Kälte', 3: 'Kühlung aus Strom', 4: 'Kühlung aus Wärme'},
		},

		cooling_building_year: {
			title: 'Baujahr der Kälteanlage',
		},

		//Kühlung aus Strom
		cooling_from_electricity: {
			title: 'Kühlung durch Strom',
			values: {
				1: 'Ja',
				2: 'Nein',
			},
		},

		//Gelieferte Kälte
		cooling_delivered: {
			title: 'Gelieferte Kühlung',
			values: {
				1: 'Ja',
				2: 'Nein',
			},
		},

		//Passive Kühlung
		cooling_passive: {
			title: 'Passive Kühlung',
			values: {
				1: 'Ja',
				2: 'Nein',
			},
		},

		//Kühlung aus Wärme
		cooling_from_warming: {
			title: 'Kühlung durch Erwärmung',
			values: {
				1: 'Ja',
				2: 'Nein',
			},
		},

		cooling_nominal_power: {
			title: 'Kühlleistung',
			values: {
				1: 'kleiner als 12 kW',
				2: 'größer als 12 kW ohne Gebäudeautomation',
				3: 'größer als 12 kW mit Gebäudeautomation',
				4: 'Klimaanlage größer als 70 kW',
			},
		},

		// Heizungsanlage
		ba_heater_type: {
			title: 'Heizungsart',
			values: {
				1: 'Konstanttemperaturkessel (Standard-Kessel)',
				2: 'Niedertemperatur-Heizkessel',
				3: 'Brennwertkessel',
				4: 'Brennwertkessel verbessert',
				5: 'Fernwärme- Übergabestation',
				6: 'Elektro-Wärmepumpe, Außenluft',
				7: 'Elektro-Wärmepumpe, Erdreich',
				8: 'Elektro-Wärmepumpe, Grundwasser',
				9: 'Elektro-Wärmepumpe, Abluft',
				10: 'zentraler ElektroSpeicher (Blockspeicher)',
				11: 'Therme (Umlaufwasserheizer)',
				12: 'Brennwerttherme',
				13: 'Ölbefeuerte Einzelöfen mit Verdampfungsbrenner',
				14: 'Kohle- oder Holzofen',
				15: 'Gasraumheizer',
				16: 'Elektro-Nachtspeicherheizung',
				17: 'Elektro-Direktheizgerät',
				18: 'Blockheizkraftwerk',
				19: 'Brennstoffzelle',
				30: 'Sonstiges',
			},
		},

		ba_heater2_type: {
			title: 'Heizungsart 2',
			values: {
				1: 'Konstanttemperaturkessel (Standard-Kessel)',
				2: 'Niedertemperatur-Heizkessel',
				3: 'Brennwertkessel',
				4: 'Brennwertkessel verbessert',
				5: 'Fernwärme- Übergabestation',
				6: 'Elektro-Wärmepumpe, Außenluft',
				7: 'Elektro-Wärmepumpe, Erdreich',
				8: 'Elektro-Wärmepumpe, Grundwasser',
				9: 'Elektro-Wärmepumpe, Abluft',
				10: 'zentraler ElektroSpeicher (Blockspeicher)',
				11: 'Therme (Umlaufwasserheizer)',
				12: 'Brennwerttherme',
				13: 'Ölbefeuerte Einzelöfen mit Verdampfungsbrenner',
				14: 'Kohle- oder Holzofen',
				15: 'Gasraumheizer',
				16: 'Elektro-Nachtspeicherheizung',
				17: 'Elektro-Direktheizgerät',
				18: 'Blockheizkraftwerk',
				19: 'Brennstoffzelle',
				30: 'Sonstiges',
			},
		},

		// Heizungsanlage
		// ba_heater2_type
		// Geändert tine 30.11.23
		ba_heater_type_18599: {
			title: 'Heizungsart nach DIN 18599',
			values: {
				1: 'Konstanttemperaturkessel (Standard-Kessel)',
				2: 'Niedertemperatur-Heizkessel',
				3: 'Brennwertkessel',
				//4: 'Brennwertkessel verbessert',
				5: 'Nah-/Fernwärme',
				6: 'Elektro-Wärmepumpe, Außenluft',
				7: 'Elektro-Wärmepumpe, Erdreich',
				8: 'Elektro-Wärmepumpe, Grundwasser',
				// 9: 'Wärmepumpe Luft/Luft',
				10: 'zentraler ElektroSpeicher (Blockspeicher)',
				11: 'Therme (Umlaufwasserheizer)',
				12: 'Wärmepumpe Abluft/Wasser',
				13: 'Ölbefeuerte Einzelöfen mit Verdampfungsbrenner',
				14: 'Kohle- oder Holzofen',
				15: 'Gasraumheizer',
				16: 'Elektro-Nachtspeicherheizung',
				17: 'Elektro-Direktheizgerät',
				18: 'Blockheizkraftwerk',
				19: 'Brennstoffzelle',
				// 22: 'Gasbetriebene Wärmepumpe',
				30: 'Sonstiges',
			},
		},

		// Steht oftmals in Schornsteinfeger Protokoll, Betriebsanleitung, Typenschild, o. ä-
		water_heating_method: {
			title: 'Wassererwärmungsmethode',
			values: {
				1: 'Konstanttemperaturkessel (Standard-Kessel)',
				2: 'Niedertemperatur-Heizkessel',
				3: 'Brennwertkessel',
				4: 'Brennwertkessel verbessert',
				5: 'Elektro-Wärmepumpe (Luft, mit Heizstab)',
				6: 'Elektro-Wärmepumpe (Erdreich, monovalent)',
				7: 'Elektro-Wärmepumpe (Grundwasser, monovalent)',
				8: 'Fernwärme-Übergabestation',
				9: 'Zentraler elektrischer Speicher',
				10: 'Gasbefeuerter Speicher',
				11: 'Therme (Umlaufwasserheizer)',
				12: 'Brennwerttherme',
				13: 'Dezentraler elektrischer Kleinspeicher',
				14: 'Dezentraler elektrischer Durchlauferhitzer',
				15: 'Dezentraler Gas-Durchlauferhitzer',
				16: 'thermische Solaranlage',
				18: 'Blockheizkraftwerk',
				19: 'Brennstoffzelle',
				30: 'Sonstiges',
			},
		},

		/**
		 * geänert tine 30.11.23
		 */
		// Steht oftmals in Schornsteinfeger Protokoll, Betriebsanleitung, Typenschild, o. ä.)
		//water_heating2_method
		water_heating_method_18599: {
			title: 'Wassererwärmungsmethode nach DIN 18599',
			values: {
				1: 'Konstanttemperaturkessel (Standard-Kessel)',
				2: 'Niedertemperatur-Heizkessel',
				3: 'Brennwertkessel',
				//4: 'Brennwertkessel verbessert',
				5: 'Nah-/Fernwärme',
				6: 'Elektro-Wärmepumpe (Luft, mit Heizstab)',
				7: 'Elektro-Wärmepumpe (Erdreich, monovalent)',
				8: 'Elektro-Wärmepumpe (Grundwasser, monovalent)',
				9: 'Elektrisch beheizter Trinkwarmwasserspeicher (zentral)',
				10: 'Gasbefeuerter Speicher',
				11: 'Therme (Umlaufwasserheizer)',
				// 12: '',
				// 13: '',
				14: 'Elektro-Durchlauferhitzer (dezentral)',
				15: 'Gas-Durchlauferhitzer (dezentral)',
				16: 'Solaranlagen zur Trinkwassererwärmung',
				// 17: '',
				18: 'Blockheizkraftwerk',
				19: 'Brennstoffzelle',
				20: 'Wasserführender Kamin',
				21: 'Wärmepumpe Abluft/Wasser',
				// 22: 'Gasbetriebene Wärmepumpe',
				30: 'Sonstiges',
			},
		},

		water_heating: {
			title: 'Wassererwärmung',
			values: {
				1: "Ja, die Warmwasserbereitung erfolgt über die Heizungsanlage",
				2: "Nein, die Warmwasserbereitung erfolgt separat.",
				3: "Nein, Verbrauch separat angeben.",
			},
		},

		water_heating2: {
			title: 'Wassererwärmung 2',
			values: {
				1: "Ja, die Warmwasserbereitung erfolgt über die 2. Heizungsanlage",
				// 2: "Nein, Verbrauch ist nicht bekannt.", // Deaktiviert, da sonst nicht in DIBt darstellbar
				3: "Nein, Verbrauch separat angeben.",
				9: "Keine Warmwasserbereitung über die zweite Heizungsanlage",
			},
		},

		water_heating2_BA: {
			title: 'Wassererwärmung 2',
			values: {
				1: "Ja",
				2: "Nein",
			},
		},

		heat_protection: {
			title: 'Hitzeschutz',
			values: {
				1: 'Ja', 2: 'Nein',
			},
		},

		ba_floor_heating: {
			title: 'Fußbodenheizung',
			values: {
				1: 'Fußbodenheizung im Wohnbereich',
				2: 'Keine Fußbodenheizung im Wohnbereich',
				3: 'teilweise Fußbodenheizung im Wohnbereich',
			},
		},

		waermepumpen_hybrid_checkbox: {
			title: 'Hybrid-Wärmepumpe',
			values: {
				1: '<b>Ja,</b> der Spitzenlasterzeuger wird nur eingesetzt, sofern der Wärmebedarf nicht mehr von der Wärmepumpe gedeckt werden kann. Zusätzlich gibt eine gemeinsame, fernansprechbare Steuerung für die Wärmepumpe und den Spitzenlasterzeuger.',
				2: 'Nein.',
			},
		},


		ba_blower_door_test: {
			title: 'Blower-Door-Test',
			values: {
				1: 'ohne Dichtheitsprüfung',
				2: 'mit Dichtheitsprüfung - Fensterlüftung',
				3: 'mit Dichtheitsprüfung - Zu-/Abluftanlage',
				4: 'mit Dichtheitsprüfung - Abluftanlage',
				5: 'mit Dichtheitsprüfung - Abluftanlage bedarfsgeführt',
			},
		},

		ba_blower_door_test_18599: {
			title: 'Blower-Door-Test nach DIN 18599',
			values: {
				1: 'I Einhaltung Dichtheit nach DIN 4108-7',
				2: 'II ohne Dichtheitsprüfung',
				3: 'III andere (von I, II oder IV abweichend)',
				4: 'IV offensichtliche Undichtheiten',
			},
		},
		ba_roof_jamb: {
			title: 'Kniestock',
		},
		ba_roof_windows: {
			title: 'Dachfenster',
		},
		ba_roof_windows_surface_area_site_1: {
			title: 'Dachfenster (Fläche Seite 1)',
		},
		ba_roof_windows_surface_area_site_2: {
			title: 'Dachfenster (Fläche Seite 2)',
		},
		ba_roof_windows_surface_area_site_3: {
			title: 'Dachfenster (Fläche Seite 3)',
		},
		ba_roof_windows_surface_area_site_4: {
			title: 'Dachfenster (Fläche Seite 4)',
		},
		ba_roof_dormers_height: {
			title: 'Dachgauben (Höhe)',
		},
		ba_roof_dormers_width: {
			title: 'Dachgauben (Breite)',
		},
		ba_roof_dormers_depth: {
			title: 'Dachgauben (Tiefe)',
		},
		ba_solar_water_temperature: {
			title: 'Solarwassererwärmung (Temperatur)',
		},
		ba_solar_size: {
			title: 'Solaranlage (Größe)',
		},
		property_space_an: {
			title: 'Gebäudenutzfläche',
		},

		// Gebäudesanierung
		insulation_measure_ceiling: {
			title: 'Dämmung (Bodenplatte, Kellerdecke)',
		},
		insulation_measure_walls: {
			title: 'Dämmung (Außenwände)',
		},
		insulation_measure_basement: {
			title: 'Dämmung (Keller)',
		},
		insulation_measure_basement_walls: {
			title: 'Dämmung (Kellerwände)',
		},
		external_wall_insulation: {
			title: 'Außenwanddämmung',
			values: {
				1: 'Ja',
				2: 'Nein',
			},
		},

		roof_insulation: {
			title: 'Dachdämmung',
			values: {
				1: 'Ja',
				2: 'Nein',
			},
		},

		ba_roof_tilt: {
			title: 'Dachneigung',
			values: {
				// 0: '0° (Flachdach)',
				15: '15°',
				20: '20°',
				25: '25°',
				30: '30°',
				35: '35°',
				40: '40°',
				45: '45°',
				50: '50°',
				55: '55°',
				60: '60°',
				65: '65°',
				70: '70°',
				75: '75°',
				80: '80°',
			},
		},

		energy_saving_lamps: {
			title: 'Energiesparlampen',
			values: {
				1: 'Ja, es sind LED- oder Energiesparlampen verbaut.',
				2: 'Nein',
			},
		},

		long_vacant: {
			title: 'Länger leerstehend',
			1: 'Ja, längerer Leerstand vorhanden.',
			2: 'Nein',
		},

		/**
		 * Bedarfsausweis
		 * Step 1
		 */
		ba_floor_plan_shape: {
			title: 'Grundrissform',
			values: {
				1: 'Rechteckig', 2: 'T-förmig', 3: 'L-förmig', 4: 'Individuell',
			},
		},


		ba_property_orientation: {
			title: 'Ausrichtung der Immobilie',
			values: {
				1: 'Nord',
				2: 'Nordost',
				3: 'Ost',
				4: 'Südost',
				5: 'Süd',
				6: 'Südwest',
				7: 'West',
				8: 'Nordwest',
			},
		},

		property_building_type_ENUM: {
			title: 'Gebäudetyp (ENUM)',
			values: {
				2: "Einfamilienhaus",
				3: "Zweifamilienhaus",
				7: "Mehrfamilienhaus",
				8: "Wohnteil gemischt genutztes Gebäude",
				10: "Sonstiges",
			},
		},

		property_building_type_18599: {
			title: 'Gebäudetyp nach DIN 18599',
			values: {
				2: "Einfamilienhaus",
				3: "Zweifamilienhaus",
				7: "Mehrfamilienhaus",
				8: "Wohnteil gemischt genutztes Gebäude",
				10: "Sonstiges",
				11: 'Einseitig angebautes Gebäude',
				12: 'Beidseitig angebautes Gebäude',
			},
		},

		property_building_type: {
			title: 'Gebäudetyp',
			values: {
				//	1: 'Einfamilienhaus',
				2: 'Einfamilienhaus (freistehend)',
				3: 'Zweifamilienhaus (freistehendes)',
				4: 'Doppelhaushälfte (einseitig angebaut)',
				5: 'Reihenendhaus (einseitig angebaut)',
				6: 'Reihenmittelhaus (beidseitig angebaut)',
				7: 'Mehrfamilienhaus (freistehend)',
				// 8: 'Wohnteil Mischgebäude (Wohnen u. Gewerbe)',
				//	9: 'Atrium-Bungalow',
				//	10: 'Winkelbungalow',
				11: 'Einseitig angebautes Gebäude',
				12: 'Beidseitig angebautes Gebäude',
			},
		},

		// § 106 GEG
		ba_property_part: {
			title: 'Immobilienteil',
			values: {
				1: 'Gesamtgebäude',
				2: 'Wohnteil Mischgebäude (Wohnen u. Gewerbe)',
			},
		},

		ba_construction_method: {
			title: 'Bauweise',
			values: {
				1: 'Massivbau (kein Holz)',
				2: 'Holzkonstruktion (Inkl. Fachwerk)',
			},
		},

		basement_construction_method: {
			title: 'Bauweise des Kellers',
			values: {
				1: 'Massivbau (kein Holz)',
				2: 'Holzkonstruktion',
			},
		},

		basement_construction_detail: {
			title: 'Wandbauart des Kellers',
			values: {// Massivbau
				1: 'Hochlochziegel oder Bimsbeton-Stein',
				2: 'Mauerwerk, 2-schalig',
				3: 'Vollziegel (bis 20cm Wandstärke)',
				4: 'Vollziegel (20-30cm Wandstärke)',
				5: 'Vollziegel (ab 30cm Wandstärke)',
				6: 'sonstige Wandaufbauten (bis 20cm Wandstärke)',
				7: 'sonstige Wandaufbauten (ab 20cm Wandstärke)', // Holzbau
				8: 'Poroton/Wärmedämmziegel',
				9: 'Porenbeton',

				21: 'Massivholzwand',
				22: 'Holz-Rahmenbau mit Dämmung',
				23: 'Fachwerkwand mit Lehmausfachung',
				24: 'Fachwerkwand mit Vollziegelausfachung',
				25: 'sonstige Holzkonstruktionen',
			},
		},
		ba_construction_detail: {
			title: 'Bauweise (Detail)',
			values: {// Massivbau
				1: 'Hochlochziegel oder Bimsbeton-Stein',
				2: 'Mauerwerk, 2-schalig',
				3: 'Vollziegel (bis 20cm Wandstärke)',
				4: 'Vollziegel (20-30cm Wandstärke)',
				5: 'Vollziegel (ab 30cm Wandstärke)',
				6: 'sonstige Wandaufbauten (bis 20cm Wandstärke)',
				7: 'sonstige Wandaufbauten (ab 20cm Wandstärke)', // Holzbau
				8: 'Poroton/Wärmedämmziegel',
				9: 'Porenbeton',

				21: 'Massivholzwand',
				22: 'Holz-Rahmenbau mit Dämmung',
				23: 'Fachwerkwand mit Lehmausfachung',
				24: 'Fachwerkwand mit Vollziegelausfachung',
				25: 'sonstige Holzkonstruktionen',
			},
		},


		ba_property_building_energyefficiency: {
			title: 'Energieeffizienz des Gebäudes',
			values: {
				1: 'Nein',
				2: 'Passivhaus',
				3: 'kfW Effizienzhaus 70',
			},
		},


		ba_external_wall_insulation: {
			title: 'Außenwanddämmung',
			0: 'keine / 0',
			1: 1,
			2: 2,
			3: 3,
			4: 4,
			5: 5,
			6: 6,
			7: 7,
			8: 8,
			9: 9,
			10: 10,
			11: 12,
			12: 14,
			13: 16,
			14: 18,
			15: 20,
			16: 22,
			17: 23,
			18: 24,
			19: 26,
			20: 28,
			21: 30,
			22: 35,
			23: 40,
		},
		ba_attic: {
			title: 'Dachboden',
			values: {
				1: 'massive Decke',
				2: 'Holzbalkendecke',
			},
		},

		ba_full_floors: {
			title: 'Normalgeschosse',
			values: {
				1: '1 Normalgeschoss',
				2: '2 Normalgeschosse',
				3: '3 Normalgeschosse',
				4: '4 Normalgeschosse',
				5: '5 Normalgeschosse',
				6: '6 Normalgeschosse',
				7: '7 Normalgeschosse',
				8: '8 Normalgeschosse',
				9: '9 Normalgeschosse',
				10: '10 Normalgeschosse',
				11: '11 Normalgeschosse',
				12: '12 Normalgeschosse',
				13: '13 Normalgeschosse',
				14: '14 Normalgeschosse',
				15: '15 Normalgeschosse',
				16: '16 Normalgeschosse',
				17: '17 Normalgeschosse',
				18: '18 Normalgeschosse',
				19: '19 Normalgeschosse',
				20: '20 Normalgeschosse',
				21: '21 Normalgeschosse',
				22: '22 Normalgeschosse',
				23: '23 Normalgeschosse',
				24: '24 Normalgeschosse',
				25: '25 Normalgeschosse',
				26: '26 Normalgeschosse',
				27: '27 Normalgeschosse',
				28: '28 Normalgeschosse',
				29: '29 Normalgeschosse',
				30: '30 Normalgeschosse',

			},
		},

		heater_building_year: {
			title: 'Baujahr der Heizung',
		},

		heater2_building_year: {
			title: 'Baujahr der 2. Heizung',
		},

		ba_V_e: {
			title: 'Beheiztes Volumen (V_e)',
		},

		ba_f_p: {
			title: 'Primärenergiefaktor für Nah-/Fernwärme',
		},

		ba_ef: {
			title: 'Emissionsfaktor für Nah-/Fernwärme',
		},

		ba_f_p_2: {
			title: 'Primärenergiefaktor für Nah-/Fernwärme (2. Anlage)',
		},

		ba_ef_2: {
			title: 'Emissionsfaktor für Nah-/Fernwärme (2. Anlage)',
		},

		ba_roof_form: {
			title: 'Dachform',
			values: {
				1: 'Flachdach / kein Dach',
				2: 'Satteldach',
			},
		},

		ba_roof_windows_form: {
			title: 'Dachfensterform',
			values: {
				1: 'Rechteckig',
				2: 'Dreieckig',
			},
		},

		ba_roof_dormers_type: {
			title: 'Gaubenart',
			values: {
				1: 'Schleppgaube',
				2: 'Giebelgaube',
			},
		},

		ba_roof_construction: {
			title: 'Dachkonstruktion',
			values: {
				1: 'massive Konstruktion',
				2: 'Holzkonstruktion',
			},
		},

		// Verteilung Warmwasser
		ba_water_splitting_pipe_type: {
			title: 'Wasserverteilungsrohrtyp',
			values: {
				1: 'zentrale Verteilung mit Zirkulation',
				2: 'zentrale Verteilung ohne Zirkulation',
				3: 'dezentrales System',
				4: 'Wohnungsweise Verteilung',
			},
		},
		ba_water2_splitting_pipe_type: {
			title: 'Wasserverteilungsrohrtyp',
			values: {
				1: 'zentrale Verteilung mit Zirkulation',
				2: 'zentrale Verteilung ohne Zirkulation',
				3: 'dezentrales System',
			},
		},

		ba_water_splitting_pipe_location: {
			title: 'Lage des Wasserverteilungsrohrs',
			values: {
				1: 'Verteilung innerhalb thermischer Hülle',
				2: 'Verteilung außerhalb thermischer Hülle',
			},
		},

		ba_water2_splitting_pipe_location: {
			title: 'Lage des Wasserverteilungsrohrs',
			values: {
				1: 'Verteilung innerhalb thermischer Hülle',
				2: 'Verteilung außerhalb thermischer Hülle',
			},
		},

		ba_windows_frame: {
			title: 'Fensterrahmen',
			values: {
				1: 'Holzrahmen', 2: 'Kunststoffrahmen', 3: 'Aluminiumrahmen', // 4: 'Kunststoff-Aluminiumrahmen ',
				// 5: 'Holz-Aluminiumrahmen',
			},
		},

		ba_windows2_usage: {
			title: 'Fensterrahmen',
			values: {
				1: 'Ja, zweite Fester-Bauart vorhanden',
				2: 'Nein',
			},
		},

		// ba_windows2_glas_type
		// ba_roof_windows_glas_type
		ba_windows_glas_type_grouped: {
			title: 'Glasart der Fenster',
			values: {
				"Kunststoff & Holzrahmen": {
					10: "1-Fachverglasung",
					11: "2-Fachverglasung ",
					12: "2-Fachverglasung (Isolierverglasung)",
					13: "3-Fachverglasung ",
					14: "3-Fachverglasung (Isolierverglasung)",
				},
				"Alu oder Stahlfenster": {
					20: "1-Fachverglasung",
					21: "2-Fachverglasung",
					22: "2-Fachverglasung (Isolierverglasung)",
					23: "3-Fachverglasung ",
					24: "3-Fachverglasung (Isolierverglasung)",
				},
				"u-Wert bekannt": {
					// 40: "Fenster mit U-Wert 0,5",
					// 41: "Fenster mit U-Wert 0,6",
					// 42: "Fenster mit U-Wert 0,7",
					43: "Fenster mit U-Wert 0,8",
					44: "Fenster mit U-Wert 0,9",
					45: "Fenster mit U-Wert 1,0",
					46: "Fenster mit U-Wert 1,1",
					47: "Fenster mit U-Wert 1,2",
					48: "Fenster mit U-Wert 1,3",
					49: "Fenster mit U-Wert 1,4",
					50: "Fenster mit U-Wert 1,5",
					51: "Fenster mit U-Wert 1,6",
					52: "Fenster mit U-Wert 1,7",
				},
			},
		},

		ba_windows_glas_type: {
			title: 'Glasart der Fenster',
			values: {
				10: "Kunststoff oder Holzrahmen (1-Fach)",
				11: "Kunststoff oder Holzrahmen (2-Fach)",
				12: "Kunststoff oder Holzrahmen (2-Fach (Wärmeschutzverglasung))",
				13: "Kunststoff oder Holzrahmen (3-Fach )",
				14: "Kunststoff oder Holzrahmen (3-Fach (Wärmeschutzverglasung))",
				20: "Alu oder Stahlfenster (1-Fach)",
				21: "Alu oder Stahlfenster (2-Fach)",
				22: "Alu oder Stahlfenster (2-Fach (Wärmeschutzverglasung))",
				23: "Alu oder Stahlfenster (3-Fach )",
				24: "Alu oder Stahlfenster (3-Fach (Wärmeschutzverglasung))",
				// 40: "Fenster mit U-Wert 0,5",
				// 41: "Fenster mit U-Wert 0,6",
				// 42: "Fenster mit U-Wert 0,7",
				43: "Fenster mit U-Wert 0,8",
				44: "Fenster mit U-Wert 0,9",
				45: "Fenster mit U-Wert 1,0",
				46: "Fenster mit U-Wert 1,1",
				47: "Fenster mit U-Wert 1,2",
				48: "Fenster mit U-Wert 1,3",
				49: "Fenster mit U-Wert 1,4",
				50: "Fenster mit U-Wert 1,5",
				51: "Fenster mit U-Wert 1,6",
				52: "Fenster mit U-Wert 1,7",
			},
		},

		ba_roof_windows_frame: {
			title: 'Fensterrahmen des Dachs',
			values: {
				1: 'Holzrahmen',
				2: 'Kunststoffrahmen',
				3: 'Aluminiumrahmen',
				4: 'Kunststoff-Aluminiumrahmen ',
				5: 'Holz-Aluminiumrahmen',
			},
		},


		ba_windows_surface_area: {
			title: 'Fensteroberfläche',
			// 1: 'Wenig Fensterfläche',
			values: {
				2: 'Normales Maß an Fensterfläche (Altbau)',
				3: 'Normales Maß an Fensterfläche (Neubau) ',
				4: 'Vollflächige Fenster-Verglasung (z. B. Wintergarten, Pfosten-Riegel-Fassade)',
			},
		},

		ba_solar: {
			title: 'Solar',
			values: {
				1: 'Ja', 2: 'Nein',
			},
		},
		ba_wall_mounted_a: {
			title: 'Anbau der Seite A',
			values: {
				1: 'Ja', 2: 'Nein',
			},
		},
		ba_wall_mounted_b: {
			title: 'Anbau der Seite B',
			values: {
				1: 'Ja', 2: 'Nein',
			},
		},
		ba_wall_mounted_c: {
			title: 'Anbau der Seite C',
			values: {
				1: 'Ja', 2: 'Nein',
			},
		},
		ba_wall_mounted_d: {
			title: 'Anbau der Seite D',
			values: {
				1: 'Ja', 2: 'Nein',
			},
		},
		ba_wall_mounted_e: {
			title: 'Anbau der Seite E',
			values: {
				1: 'Ja', 2: 'Nein',
			},
		},
		ba_wall_mounted_f: {
			title: 'Anbau der Seite F',
			values: {
				1: 'Ja', 2: 'Nein',
			},
		},
		ba_wall_mounted_g: {
			title: 'Anbau der Seite G',
			values: {
				1: 'Ja', 2: 'Nein',
			},
		},
		ba_wall_mounted_h: {
			title: 'Anbau der Seite H',
			values: {
				1: 'Ja', 2: 'Nein',
			},
		},
		ba_wall_length_a: {
			title: 'Wandlänge der Seite A',
		},
		ba_wall_length_b: {
			title: 'Wandlänge der Seite B',
		},
		ba_wall_length_c: {
			title: 'Wandlänge der Seite C',
		},
		ba_wall_length_d: {
			title: 'Wandlänge der Seite D',
		},
		ba_wall_length_e: {
			title: 'Wandlänge der Seite E',
		},
		ba_wall_length_f: {
			title: 'Wandlänge der Seite F',
		},
		ba_wall_length_g: {
			title: 'Wandlänge der Seite G',
		},
		ba_wall_length_h: {
			title: 'Wandlänge der Seite H',
		},

		ba_solar_type: {
			title: 'Solartyp',
			values: {
				1: 'monokristallines Silizium',
				2: 'polykristallines Silizium',
			},
		},


		ba_pv_type: {
			title: 'PV-Typ',
			values: {
				1: 'monokristallines Silizium',
				2: 'polykristallines Silizium',
			},
		},

		ba_solar_collector_type: {
			title: 'Solarkollektortyp',
			values: {
				1: 'Röhrenkollektoren',
				2: 'Flachkollektor',
			},
		},

		ba_solar_tilt: {
			title: 'Neigung der Solaranlage',
			values: {
				0: 'horizontal',
				30: '30°',
				45: '45°',
				60: '60°',
				90: '90°',
			},
		},

		ba_solar_orientation: {
			title: 'Ausrichtung der Solaranlage',
			values: {
				1: 'Nord',
				2: 'Nordost',
				3: 'Ost',
				4: 'Südost',
				5: 'Süd',
				6: 'Südwest',
				7: 'West',
				8: 'Nordwest',
			},
		},

		ba_pv_tilt: {
			title: 'Neigung der Photovoltaikanlage',
			values: {
				0: 'horizontal',
				30: '30°',
				45: '45°',
				60: '60°',
				90: '90°',
			},
		},

		ba_pv_orientation: {
			title: 'Ausrichtung der Photovoltaikanlage',
			values: {
				1: 'Nord',
				2: 'Nordost',
				3: 'Ost',
				4: 'Südost',
				5: 'Süd',
				6: 'Südwest',
				7: 'West',
				8: 'Nordwest',
			},
		},

		owner_lives_in_property: {
			title: 'Eigentümer wohnt in der Immobilie',
			values: {
				1: "<b>Ja,</b> ein Eigentümer bewohnt eine Wohneinheit oder es waren vor dem Einbau der aktuellen Heizung ebenfalls Einzelraum-Stromdirektheizungen vorhanden.",
				2: "Nein.",
			},
		},

		previous_heater_also_electric_single_heater: {
			title: 'Vorherige Heizung auch elektrische Einzelheizung',
			values: {
				1: "Ja, vorher waren ebenfalls Einzelraum-Stromdirektheizungen vorhanden.",
				2: "Nein, der Heizungstyp hat sich verändert.",
			},
		},

		biomasse_checkbox_feste_biomasse: {
			title: 'Biomasse',
			values: {
				1: "<b>Ja,</b> der Kessel der Heizungsanlage ist automatisch beschickt sowie der Energieträger besteht aus Rohstoffen, die ökologisch nachhaltig sind.",
				2: "Nein.",
			},
		},

		biomasse_checkbox_fluessige_biomasse: {
			title: 'Biomasse (Gas/Öl)',
			values: {
				1: "<b>Ja,</b> 65 % des 1. Energieträgers stammen aus erneuerbaren Quellen.",
				2: "Nein.",
			},
		},

		ba_solar_collector_keymark_certified: {
			title: 'Solarkollektor Keymark-zertifiziert',
			values: {
				1: "<b>Ja,</b> die Solar-Module besitzen das Siegel 'Solar Keymark'",
				2: "Nein.",
			},
		},

		ba_heater_temperature: {
			title: 'Heizungstemperatur',
			values: {
				1: '70/55 ° C', 2: '55/45 ° C', //3: '<40 ° C',
			},
		},

		ba_heater_temperature_18599: {
			title: 'Heizungstemperatur nach DIN 18599',
			values: {
				1: '90/70 ° C',
				2: '70/55 ° C',
				3: '55/45 ° C',
				4: '35/28 ° C',
			},
		},

		ba_water_storage_type: {
			title: 'Wasserspeichertyp',
			values: {
				1: 'indirekt beheizter Speicher',
				// 2: 'indirekt beheizter Speicher',
				3: 'gasbeheizter Speicher',
				4: 'elektrischer beheizter Speicher',
				// 5: 'elektrischer beheizter Speicher',
			},
		},

		ba_water2_storage_type: {
			title: 'Wasserspeichertyp',
			values: {
				1: 'indirekt beheizter Speicher',
				// 2: 'indirekt beheizter Speicher',
				3: 'gasbeheizter Speicher',
				4: 'elektrischer beheizter Speicher',
				// 5: 'elektrischer beheizter Speicher',
			},
		},

		ba_heater_night_shutdown: {
			title: 'Nachtabschaltung der Heizung',
			values: {1: 'Nachtabschaltung', 2: 'Nachtabsenkung', 3: 'Keine Abschaltung/Absenkung'},
		},

		ba_heater_location: {
			title: 'Heizungsstandort',
			values: {1: 'Innerhalb thermischer Hülle', 2: 'Außerhalb thermischer Hülle'},
		}, ba_heater2_location: {
			title: 'Heizungsstandort',
			values: {1: 'Innerhalb thermischer Hülle', 2: 'Außerhalb thermischer Hülle'},
		},
		ba_water_location: {
			title: 'Standort der Warmwasserbereitung',
			values: {1: 'Innerhalb thermischer Hülle', 2: 'Außerhalb thermischer Hülle'},
		},
		ba_water2_location: {
			title: 'Standort der 2. Warmwasserbereitung',
			values: {1: 'Innerhalb thermischer Hülle', 2: 'Außerhalb thermischer Hülle'},
		},


		ba_heater_regulator: {
			title: 'Heizungsregler',
			values: {
				1: 'ungeregelt, mit zentraler Zulauftemperaturregelung',
				2: 'Führungsraumregelung- oder Ein-Rohr-Heizung',
				3: 'Raumtemperaturregelung (elektromechanisch/elektronisch)',
				4: 'P-Regler (vor 1988)',
				5: 'P-Regler, 2-Punkt-Regler (Hysterese 0,5 K) ≤',
				6: 'PI-Regler',
				7: 'PID-Regler (mit Optimierungsfunktion, management, adaptivem Regler)',
			},
		},
		ba_heater_tube_system: {
			title: 'Heizungssystem',
			values: {1: '1-Rohr-System', 2: '2-Rohr-System'},
		},

		ba_heater_ventilation_rate: {
			title: 'Lüftungsrate des Heizungssystems',
			values: {
				1: 'Ohne Luftdichtheitsprüfung (0,7/h)',
				2: 'Mit Luftdichtheitsprüfung (0,6/h)',
				3: 'Undicht (1/h)',
			},
		},


		ba_heater_heating_hydraulic_balancing: {
			title: 'Hydraulischer Abgleich der Heizung',
			values: {1: 'Mit hydraulischem Abgleich', 2: 'Ohne hydraulischem Abgleich'},
		},

		ba_heater_tube_type: {
			title: 'Heizungsrohrtyp',
			values: {
				1: 'I (Etagenringtyp)',
				2: 'IIa (Etagenverteilertyp Heizkörper)',
				3: 'IIb (Etagenverteilertyp Fußbodenheizung)',
				4: 'III (Steigestrangtyp)',
				5: 'IV (Strahlungs- und Luftheizung)',
			},
		},
		ba_heater2_tube_type: {
			title: 'Heizungsrohrtyp',
			values: {
				1: 'I (Etagenringtyp)',
				2: 'IIa (Etagenverteilertyp Heizkörper)',
				3: 'IIb (Etagenverteilertyp Fußbodenheizung)',
				4: 'III (Steigestrangtyp)',
				5: 'IV (Strahlungs- und Luftheizung)',
			},
		},

		ba_heater_distribution: {
			title: 'Heizungsverteilung',
			values: {1: 'zentrale Verteilung', 3: 'Wohnungsweise Verteilung', 4: 'Dezentrales System'},
		},

		ba_heater_distribution_building_year: {
			title: 'Baujahr des Rohrleitungssystems',
		},

		ba_heater_distribution_insulated: {
			title: 'Dämmung der freiliegenden Heizungsrohre',
			values: {1: 'Rohre sind gedämmt.', 2: 'Ungedämmt'},
		},

		ba_heater_storage_type: {
			title: 'Heizungsspeichertyp',
			values: {
				// 1: 'Elektro-Zentralspeicher',
				// 2: 'Pufferspeicher Elektro-Wärmepumpe',
				// 3: 'Pufferspeicher für Holzkessel',
				// 4: 'Kein Speicher vorhanden',
				5: 'Pufferspeicher nicht vorhanden',
				6: 'Pufferspeicher vorhanden',
			},
		},

		ba_heater2_storage_type: {
			title: 'Heizungsspeichertyp',
			values: {
				// 1: 'Elektro-Zentralspeicher',
				// 2: 'Pufferspeicher Elektro-Wärmepumpe',
				// 3: 'Pufferspeicher für Holzkessel',
				// 4: 'Kein Speicher vorhanden',
				5: 'Pufferspeicher nicht vorhanden',
				6: 'Pufferspeicher vorhanden',
			},
		},


		ba_water_building_year: {
			title: 'Jahr des Warmwassersystems',
		},

		ba_water2_building_year: {
			title: 'Jahr des 2. Warmwassersystems',
		},

		property_address: {
			title: 'Straße und Hausnummer des Objekts',
		},

		property_zip: {
			title: 'PLZ des Objekts',
		},

		property_city: {
			title: 'Stadt des Objekts',
		},


		sun_protection: {
			title: 'Sonnenschutz',
			values: {
				1: 'Kein Sonnen- / Blendschutz',
				2: 'Sonnen- und/oder Blendschutz (Rolladen, Jalousien), automatisch betrieben',
				3: 'Nur Blendschutz(meist bei Bürogebäuden)',
				4: 'Nur Blendschutz, lichtlenkend (meist bei Bürogebäuden)',
			},
		},
		sun_protection_18599: {
			title: 'Sonnenschutz nach DIN 18599',
			values: {
				1: '<b>Ja,</b> das Objekt besitzt an Ost-, Süd und Westfenstern einen außenliegenden Sonnenschutz.',
				2: 'Nein es ist kein Sonnenschutz vorhanden.',
			},
		},

		property_automation: {
			title: 'Immobilienautomation',
			values: {
				1: 'Sehr viel automatisiert (Kategorie A)',
				2: 'viel automatisiert (Kategorie B)',
				3: 'teils automatisiert (Kategorie C)',
				4: 'nicht automatisiert (Kategorie D)',
			},
		},


		ba_roof_glas_dome: {
			title: 'Dachglaskuppel',
			values: {1: 'Ja, Glasdach, ein Lichtband oder eine Lichtkuppel?', 2: 'Nein'},
		},

		ba_curtain_wall: {
			title: 'Vorhangfassade',
			values: {1: 'Ja, Vorhangfassade bzw. Vorhangwand vorhanden', 2: 'Nein'},
		},
		durchlauferhitzer_elektronisch_geregelt: {
			title: 'Regelung der Durchlauferhitzer',
			values: {1: '<b>Ja,</b> mein Durchlauferhitzer ist elektronisch geregelt.', 2: 'Nein'},
		},
	},
	va_measures: {
		has_insulating_glazing: {
			title: 'Besitzt Ihr Gebäude Isolier- oder Wärmeschutzverglasung?',
			values: {
				1: "Ja",
				2: "Nein",
			},
		},
		roof_retrofitted_insulation: {
			title: 'Wurde das Dach nachträglich gedämmt? ',
			values: {
				1: "Ja",
				2: "Nein",
			},
		},
		top_floor_ceiling_insulated_thicker_12cm: {
			title: 'Ist die oberste Geschossdecke gedämmt (mehr als 12 cm)? ',
			values: {
				1: "Ja",
				2: "Nein",
			},
		},
		exterior_walls_retrofitted_insulation: {
			title: 'Wurden die Außenwände nachträglich gedämmt? ',
			values: {
				1: "Ja",
				2: "Nein",
			},
		},
		basement_ceiling_or_floor_slab_insulated: {
			title: 'Ist die Kellerdecke oder Bodenplatte gedämmt? ',
			values: {
				1: "Ja",
				2: "Nein",
			},
		},
	},
	user: {
		id: {
			title: 'ID',
		},
		uuid: {
			title: 'UUID',
		},
		first_name: {
			title: 'Vorname',
		},
		last_name: {
			title: 'Nachname',
		},
		email: {
			title: 'E-Mail',
		},
		user_type: {
			title: 'Benutzertyp',
		},
		salutation: {
			title: 'Anrede',
		},
		order_type: {
			title: 'Bestelltyp',
		},
		address: {
			title: 'Adresse',
		},
		address_zip: {
			title: 'PLZ',
		},
		address_city: {
			title: 'Stadt',
		},
		address_country: {
			title: 'Land',
		},
		payment_mollie_customer_id: {
			title: 'Mollie-Kunden-ID',
		},
		payment_mollie_mandate_id: {
			title: 'Mollie-Mandats-ID',
		},
		password: {
			title: 'Passwort',
		},
	},
};
